export default __webpack_public_path__ + "static/media/indexxLogo.f85a63e3.svg";